
import { TranslationsTypes } from '@app/models';

export const toBoolean = (value: any): boolean => {
    switch (value) {
        case true:
        case 'true':
        case 'True':
        case 'TRUE':
        case 1:
        case '1':
        case 'yes':
        case 'Yes':
        case 'YES':
            return true;
        default:
            return false;
    }
};

export const booleanStringToYesNo = (value: string): TranslationsTypes => {
    if (toBoolean(value)) {
        return 'YES';
    }

    return 'NO';
};

export const booleanToYesNo = (value: boolean): TranslationsTypes => {
    if (value) {
        return 'YES';
    }

    return 'NO';
};